// extracted by mini-css-extract-plugin
export default {"popupWrapper":"unsavedChangesWarning_popupWrapper__Yu+MH","text":"unsavedChangesWarning_text__lJDlk","footer":"unsavedChangesWarning_footer__+w78Q"};